<mat-card-header class="card-header">
    <mat-card-title class="card-title">
        <ng-content></ng-content>
    </mat-card-title>
</mat-card-header>
